import { makeStyles } from '@material-ui/core/styles';

export const useCenteredDialogStyles = makeStyles({
  paper: {
    overflow: 'visible',
    margin: 'auto',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
